import { Component, OnInit } from '@angular/core';
import packageJson from '../../../../package.json';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TermsComponent } from 'src/app/pages/terms/terms.component';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  version: string

  constructor(private _modal: NgbModal) { }

  ngOnInit(): void {
    this.version = packageJson.version;
  }


  showTermsModal() {
    this._modal.open(TermsComponent, { centered: true });
  }


}
